import { gql } from "@apollo/client"
import { NOTIFICATION_FRAGMENT } from "@graphql"

const GET_NOTIFICATIONS = gql`
  ${NOTIFICATION_FRAGMENT}
  
  query($id: ID) {
    event(id: $id) {
      id
      no_of_bookings
		  no_of_booking_confirmations_sent
      notifications(orderBy: [{ column: CREATED_AT, order: DESC }]) {
        ...NotificationFields
      }
    }
  }
`

export { GET_NOTIFICATIONS }